import { useApp } from '../../contexts/AppContext';
import Chest from './Events/Chest';
import Meerkat from './Events/Meerkat';

const Popups = () => {
  const { event } = useApp();
  if (!event) return;
  if (event.type === 'meerkat') return <Meerkat />;
  if (event.type === 'chest') return <Chest />;
};

export default Popups;
